import './disable-vue-global-warnings.ts';
import '../../frontend/phi3d/src/styles/scss/app.scss';

// vendor dependencies
import '@frontend/import-jquery';
import 'jquery-ui/dist/jquery-ui.js';
import 'bootstrap';

// our svg
import SVG from '../../frontend/phi3d/src/assets/icons.inline.svg';

// libraries to be lifted to globals
import * as debug from '@frontend/debug.js';
import * as geometry_and_math from '@frontend/geometry_and_math.js';
import * as help from '@frontend/help.js';
import * as initialization_and_event_handling from '@frontend/initialization_and_event_handling.js';
import * as input_output from '@frontend/input_output.js';
import * as import_3d_scan_data from '@frontend/import_3d_scan_data.js';
import * as lattice from '@frontend/lattice.js';
import * as non_graphical_ui_actions from '@frontend/non_graphical_ui_actions.js';
import * as scene from '@frontend/scene.js';
import * as colours_materials_appearance from '@frontend/colours_materials_appearance.js';
import * as ui_display from '@frontend/ui_display.js';
import * as circularity from '@frontend/circularity.js';
import * as uid_continuity from '@frontend/uid_continuity.js';
import * as uil_continuity from '@frontend/uil_continuity.js';
import * as ui_logic from '@frontend/ui_logic.js';
import * as user_authentication from '@frontend/user_authentication';
import * as utility from '@frontend/utility.js';
import * as extra_phi_file_data from '@frontend/extra_phi_file_data.js';
import * as reference_sketches from '@frontend/reference_sketches.js';
import * as intermediate_graph from '@frontend/intermediate_graph.js';
import * as vars_and_data_structures from '@frontend/vars_and_data_structures';
import AppComponent from '@frontend/App';
import App from '@frontend/application-container';
import * as API from '@phi/frontend/api/calls';
import { createApp } from 'vue';
import { frontend_service_container } from '@phi/frontend/service-container';

const lift_to_global = (o) => {
    for (const [k, v] of Object.entries(o))
        globalThis[k] = v;
};

// list imports to global state
[
    debug,
    geometry_and_math,
    help,
    initialization_and_event_handling,
    input_output,
    import_3d_scan_data,
    lattice,
    non_graphical_ui_actions,
    scene,
    colours_materials_appearance,
    ui_display,
    circularity,
    uid_continuity,
    uil_continuity,
    ui_logic,
    user_authentication,
    utility,
    extra_phi_file_data,
    reference_sketches,
    intermediate_graph,
    vars_and_data_structures,
].forEach(lift_to_global);

window.App = App;
window.API = API;
window.service_container = frontend_service_container;

document.body.appendChild((() => {
    const elem = document.createElement('div');
    elem.innerHTML = SVG;
    const child = elem.firstElementChild;
    if (!child) throw new Error('could not load SVG');
    child.style.display = 'none';
    return child;
})());

createApp(AppComponent).mount('#app');
